





























































































import { editFactory, ListLoadBehavior } from '@/main/pages';
import { apiProvider as apiProviderLeads } from '@/modules/crm/CustomerLeads/api';
import { showAlert } from '@/main/utils/notifications';
import { openList } from '@/main/router/routerPath';
import dayJs from 'dayjs';

import CreateModal from '../../servis/zakazka/components/CreateModal.vue';
import { store } from './store/edit';
import { NAME, ZakazkaNAME, LeadStatus, LeadArea, FollowupStatus } from './constants';

export default editFactory(NAME, store).extend({
	components: {
		CreateModal,
	},
	data() {
		return {
			showInfoSideBar: false,
			isLeadStatusLost: false,
			isDisableCreate: this.LeadArea === LeadArea.Sales,
		};
	},
	computed: {
		notificationTitle(): string {
			return this.LocalizeChyboveHlasky('DMS3_InfoTitle');
		},
	},
	methods: {
		validatePlannedCallDate() {
			if (dayJs(this.PlannedCallDate?.toString()).diff(dayJs(this.ExpectedPurchaseDate?.toString()), 'millisecond') > 0) {
				showAlert({
					message: this.LocalizeChyboveHlasky('LeadPlanDateValidate'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				this.PlannedCallDate = null;
			}
		},
		changeLeadStatus() {
			this.FollowUpStatus = FollowupStatus.Closed;
			if (this.LeadStatus === LeadStatus.Lost) {
				this.resetValidationRules(true);
			} else {
				(this.validationRules as { SaleDate: { required: boolean } }).SaleDate.required = true;
				(this.validationRules as { PlannedCallDate: { required: boolean } }).PlannedCallDate.required = true;
				(this.validationRules as { ExpectedPurchaseDate: { required: boolean } }).ExpectedPurchaseDate.required = true;
				this.isLeadStatusLost = false;
				this.isDisableCreate = this.LeadArea === LeadArea.Sales;
				this.resetValidationRules(false);
			}
		},
		async createOrder() {
			const isValid = await this.validate();
			if (!isValid) {
				showAlert({
					message: this.LocalizeChyboveHlasky('InvalidData'),
					title: this.LocalizeChyboveHlasky('errorTitle'),
					options: {
						type: 'error',
						customClass: 'message-box--max-content-width message-box--top-aligned-icon',
						closeOnPressEscape: true,
						closeOnClickModal: true,
					},
				});
			} else {
				this.showConfirm({
					message: this.LocalizeChyboveHlasky('LeadWON'),
					title: 'Notification',
					options: {
						type: 'info',
						cancelButtonText: this.Localize('cmdStorno'),
						confirmButtonText: this.Localize('Ok'),
						callback: async (action) => {
							if (action === 'confirm') {
								this.LeadStatus = LeadStatus.Won;
								await this.saveClick(false);
								openList(ZakazkaNAME);
							}
						},
					},
				});
			}
		},
		loadedData() {
			this.checkForFollowUpDate();
			if (this.LeadArea === LeadArea.Sales) {
				this.resetValidationRules(true);
			}
		},
		async saveClick(isCreateClick = true) {
			if (isCreateClick && this.LeadStatus === LeadStatus.Won) {
				this.showNotification({ title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'), message: this.LocalizeChyboveHlasky('LeadWonSave') });
			}
			await this.save(isCreateClick);
		},
		async checkForFollowUpDate() {
			const { data: followUpResp } = await apiProviderLeads.checkFollowupDate();
			this.showInfoSideBar = followUpResp;
		},
		resetValidationRules(isLeadSalesOrLost: boolean) {
			if (isLeadSalesOrLost) {
				this.SaleDate = null;
				this.PlannedCallDate = null;
				this.ExpectedPurchaseDate = null;
				(this.validationRules as { SaleDate: { required: boolean } }).SaleDate.required = false;
				(this.validationRules as { PlannedCallDate: { required: boolean } }).PlannedCallDate.required = false;
				(this.validationRules as { ExpectedPurchaseDate: { required: boolean } }).ExpectedPurchaseDate.required = false;
				this.isLeadStatusLost = true;
				this.isDisableCreate = true;
			} else {
				(this.validationRules as { SaleDate: { required: boolean } }).SaleDate.required = true;
				(this.validationRules as { PlannedCallDate: { required: boolean } }).PlannedCallDate.required = true;
				(this.validationRules as { ExpectedPurchaseDate: { required: boolean } }).ExpectedPurchaseDate.required = true;
				this.isLeadStatusLost = false;
				this.isDisableCreate = this.LeadArea === LeadArea.Sales;
			}
		},
	},
});
